import React from "react";
import { Tabs, Tab, Box, styled } from "@mui/material";

const StyledTab = styled(Tab)(() => ({
  minHeight: "72px",
  minWidth: "200px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 500,
  padding: "12px 24px",
  color: "#666",
  "&.Mui-selected": {
    color: "#4E84C4",
  },
  "& .MuiTab-iconWrapper": {
    marginBottom: "4px",
  },
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "2px solid #e8e8e8",
  "& .MuiTabs-flexContainer": {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  "& .MuiButtonBase-root": {
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#1976d2",
    height: "3px",
  },
}));

const TabComponent = ({ tabList, tabValue, handleTabChange }) => {
  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      <StyledTabs value={tabValue} onChange={handleTabChange} centered>
        {tabList.map((tab, id) => {
          return (
            <StyledTab
              key={id}
              icon={
                <img
                  src={id === tabValue ? tab.active_icon : tab.icon}
                  alt={tab.label}
                  height={30}
                />
              }
              label={tab.label}
              aria-label={tab.ariaLabel}
            />
          );
        })}
      </StyledTabs>
      {tabList[tabValue].component}
    </Box>
  );
};

export default TabComponent;
